module.exports = __webpack_public_path__ + "img/plan_t4.3c3fa69e.webp";